<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form justify-content-center text-left"
                    role="document"
                >
                    <div class="modal-content">
                        <div class="modal-header">
                            <p
                                class="title-modal"
                                v-text="'Donation Box Widget'"
                            ></p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img
                                    src="@/assets/images/close-dialog.svg"
                                    alt="close-icon"
                                />
                            </button>
                        </div>
                        <vue-custom-scrollbar class="scroll-area"
                                              style="width: 100%; overflow-x: hidden"
                                              :settings="modalScrollbarSettings">
                            <div class="modal-body mt-2">
                                <div class="row">
                                    <div class="col-6">
                                        <TextField
                                            v-model="name"
                                            name="name"
                                            label="Widget Name"
                                            :disabled="isReadOnly"
                                        />
                                        <div class="c-tab-list mb-4">
                                            <TabItem
                                                v-for="tab in tabs"
                                                :key="tab.value"
                                                :data="tab"
                                                :activeTab="activeTab"
                                                @handleChangeTab="handleChangeTab"
                                            />
                                        </div>
                                        <template v-if="activeTab === 1">
                                            <div class="position-relative">
                                                <div v-if="isReadOnly" class="disabled-readonly"></div>
                                                <SelectField
                                                    v-if="!isReadOnly"
                                                    v-model="campaign"
                                                    name="campaign"
                                                    label="Campaign"
                                                    :options="filterCampaignItems"
                                                    :has-icon="true"
                                                    :show-tooltip="false"
                                                >
                                                    <template #append-icon>
                                                        <a @click.prevent="() => {}">
                                                            <i
                                                                class="fa fa-chevron-circle-down mt-2"
                                                                style="
                                                                  font-size: 20px;
                                                                  color: #40b8dc;
                                                              "
                                                            />
                                                        </a>
                                                    </template>
                                                </SelectField>
                                                <TextField
                                                    v-else
                                                    v-model="campaign"
                                                    name="campaign_title"
                                                    label="Campaign"
                                                />
                                                <SelectField
                                                    v-if="!isReadOnly && !isLoadingDesignation"
                                                    v-model="designation"
                                                    name="designation"
                                                    label="Designation (optional)"
                                                    :options="designationList"
                                                    :has-icon="true"
                                                    :show-tooltip="false"
                                                >
                                                    <template #append-icon>
                                                        <a @click.prevent="() => {}">
                                                            <i
                                                                class="fa fa-chevron-circle-down mt-2"
                                                                style="
                                                                  font-size: 20px;
                                                                  color: #40b8dc;
                                                              "
                                                            />
                                                        </a>
                                                    </template>
                                                </SelectField>
                                                <TextField
                                                    v-else
                                                    v-model="designation"
                                                    name="designation"
                                                    label="Designation"
                                                />
                                                <CheckboxField
                                                    v-model="allowChangeDesignation"
                                                    name="allowChangeDesignation"
                                                    label="Allow donor to change designation"
                                                />
                                                <TextField
                                                    v-model="title"
                                                    name="title"
                                                    label="Title"
                                                />
                                                <TextField
                                                    v-model="amount"
                                                    name="amount"
                                                    label="Amount"
                                                    type="number"
                                                />
                                                <TextField
                                                    v-model="eventAmount"
                                                    name="eventAmount"
                                                    label="Event Amount (optional)"
                                                    type="number"
                                                />
                                                <CheckboxField
                                                    v-model="allowChangeAmount"
                                                    name="allowChangeAmount"
                                                    label="Allow donor to change amount"
                                                />
                                            </div>
                                        </template>
                                        <template v-if="activeTab === 2">
                                            <div class="position-relative">
                                                <div v-if="isReadOnly" class="disabled-readonly"></div>
                                                <DesignItem
                                                    label="Background color">
                                                    <ColorField
                                                        name="backgroundColor"
                                                        v-model="
                                                          panelDesign.backgroundColor
                                                      "
                                                    />
                                                </DesignItem>
                                                <DesignItem label="Text color">
                                                    <ColorField
                                                        name="textColor"
                                                        v-model="panelDesign.textColor"
                                                    />
                                                </DesignItem>
                                                <DesignItem label="Amount color">
                                                    <ColorField
                                                        name="amountColor"
                                                        v-model="
                                                          panelDesign.amountColor
                                                      "
                                                    />
                                                </DesignItem>
                                                <DesignItem label="Border color">
                                                    <ColorField
                                                        name="borderColor"
                                                        v-model="
                                                          panelDesign.borderColor
                                                      "
                                                    />
                                                </DesignItem>
                                                <DesignItem label="Border size">
                                                    <RangeField
                                                        name="borderSize"
                                                        v-model="panelDesign.borderSize"
                                                        :min-value="panelDesign.borderSizeMin"
                                                        :max-value="panelDesign.borderSizeMax"
                                                        :step="panelDesign.borderSizeStep"
                                                    />
                                                </DesignItem>
                                                <DesignItem label="Border radius">
                                                    <RangeField
                                                        name="borderRadius"
                                                        v-model="
                                                          panelDesign.borderRadius
                                                      "
                                                        :min-value="panelDesign.borderRadiusMin"
                                                        :max-value="panelDesign.borderRadiusMax"
                                                        :step="panelDesign.borderRadiusStep"
                                                    />
                                                </DesignItem>
                                            </div>
                                        </template>
                                        <template v-if="activeTab === 3">
                                            <div class="position-relative">
                                                <div v-if="isReadOnly" class="disabled-readonly"></div>
                                                <DesignItem
                                                    label="Button text color">
                                                    <ColorField
                                                        name="textColor"
                                                        v-model="buttonDesign.textColor"
                                                    />
                                                </DesignItem>
                                                <DesignItem label="Button color">
                                                    <ColorField
                                                        name="color"
                                                        v-model="buttonDesign.color"
                                                    />
                                                </DesignItem>
                                                <DesignItem
                                                    label="Button border color">
                                                    <ColorField
                                                        name="borderColor"
                                                        v-model="
                                                          buttonDesign.borderColor
                                                      "
                                                    />
                                                </DesignItem>
                                                <DesignItem label="Border size">
                                                    <RangeField
                                                        name="borderSize"
                                                        v-model="
                                                          buttonDesign.borderSize
                                                      "
                                                        :min-value="buttonDesign.borderSizeMin"
                                                        :max-value="buttonDesign.borderSizeMax"
                                                        :step="buttonDesign.borderSizeStep"
                                                    />
                                                </DesignItem>
                                                <DesignItem label="Border radius">
                                                    <RangeField
                                                        name="borderRadius"
                                                        v-model="
                                                          buttonDesign.borderRadius
                                                      "
                                                        :min-value="buttonDesign.borderRadiusMin"
                                                        :max-value="buttonDesign.borderRadiusMax"
                                                        :step="buttonDesign.borderRadiusStep"

                                                    />
                                                </DesignItem>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="col-6">
                                        <div class="mb-1 text-secondary">
                                            HTML Code:
                                        </div>
                                        <TextField
                                            v-model="htmlCode"
                                            name="htmlCode"
                                            readonly
                                            class-wrapper="html-code"
                                        >
                                            <template #append-icon>
                                                <a href="javascript:;" @click="() => {
                                                    copyToClipboard(htmlCode);
                                                }">
                                                    <img
                                                        src="~@/assets/images/copy.svg"
                                                    />
                                                </a>
                                            </template>
                                        </TextField>
                                        <div class="mb-1 text-secondary">
                                            Preview:
                                        </div>
                                        <div
                                            class="c-preview"
                                            :style="{
                                              backgroundColor:
                                                  panelDesign.backgroundColor,
                                              borderColor:
                                                  panelDesign.borderColor,
                                              borderWidth: `${panelDesign.borderSize}px`,
                                              borderRadius: `${panelDesign.borderRadius}px`,
                                          }"
                                        >
                                            <div
                                                class="c-preview__title"
                                                :style="{
                                                  color: panelDesign.textColor,
                                              }"
                                            >
                                                {{ title }}
                                            </div>
                                            <div
                                                class="c-preview__amount"
                                                :style="{
                                                  color: panelDesign.amountColor,
                                              }"
                                            >
                                                ${{ amountCurrency }}
                                            </div>
                                            <div class="c-preview__description"
                                                 :style="{
                                                  color: panelDesign.textColor,
                                              }"
                                            >
                                                {{ description }}
                                            </div>
                                            <button
                                                class="btn c-preview__btn"
                                                :style="{
                                                  backgroundColor:
                                                      buttonDesign.color,
                                                  color: buttonDesign.textColor,
                                                  borderColor:
                                                      buttonDesign.borderColor,
                                                  borderWidth: `${buttonDesign.borderSize}px`,
                                                  borderRadius: `${buttonDesign.borderRadius}px`,
                                              }"
                                                v-if="buttonLabel"
                                            >
                                                {{ buttonLabel }}
                                            </button>
                                        </div>
                                        <div class="position-relative">
                                            <div v-if="isReadOnly" class="disabled-readonly"></div>
                                            <TextField
                                                :class="{'d-none': activeTab !== 1}"
                                                v-model="buttonLabel"
                                                name="buttonLabel"
                                                label="Button label"
                                            />
                                            <TextareaField
                                                :class="{'d-none': activeTab !== 1}"
                                                v-model="description"
                                                name="description"
                                                label="Description"
                                                rows="3"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div
                                        class="d-flex justify-content-center mt-2">
                                        <button
                                            v-if="!isReadOnly"
                                            v-text="'Save'"
                                            class="btn-dialog btn-sm ok-btn"
                                            @click="save"
                                        ></button>
                                        <button
                                            v-if="isReadOnly"
                                            v-text="'Close'"
                                            class="btn-dialog btn-sm ok-btn"
                                            @click="closeModal"
                                        ></button>
                                    </div>
                                </div>
                            </div>
                        </vue-custom-scrollbar>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import TextField from '@/commons/FormElements/TextField.vue';
import TabItem from '@/components/widgets/components/TabItem.vue';
import DesignItem from '@/components/widgets/components/DesignItem.vue';
import SelectField from '@/commons/FormElements/SelectField.vue';
import CheckboxField from '@/commons/FormElements/CheckboxField.vue';
import TextareaField from '@/commons/FormElements/TextareaField.vue';
import ColorField from '@/commons/FormElements/ColorField.vue';
import RangeField from '@/commons/FormElements/RangeField.vue';
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
    name: 'ModalWidgetDonation',
    components: {
        TextField,
        TabItem,
        SelectField,
        CheckboxField,
        TextareaField,
        ColorField,
        RangeField,
        DesignItem,
        vueCustomScrollbar
    },
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        data: Object,
        campaignTitle: {
            type: String,
            default: () => ''
        },
        designationName: {
            type: String,
            default: () => ''
        },
        filterCampaignItems: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            modalScrollbarSettings: {
                maxScrollbarLength: 350,
                wheelPropagation: false
            },
            name: '',
            campaign: '',
            designation: '',
            designationList: [],
            title: 'Title',
            amount: '0',
            eventAmount: '',
            allowChangeDesignation: true,
            allowChangeAmount: true,
            htmlCode: '',
            buttonLabel: 'Donate',
            description: 'Lorem ipsum dolor',
            tabs: [
                {value: 1, label: 'Content'},
                {value: 2, label: 'Panel'},
                {value: 3, label: 'Button'},
            ],
            activeTab: 1,
            panelDesign: {
                backgroundColor: '#fff',
                textColor: '#212830',
                amountColor: '#2797FF',
                borderColor: '#DEDFE3',
                borderSize: 0,
                borderSizeMin: 0,
                borderSizeMax: 100,
                borderSizeStep: 1,
                borderRadius: 0,
                borderRadiusMin: 0,
                borderRadiusMax: 100,
                borderRadiusStep: 1,
            },
            buttonDesign: {
                textColor: '#fff',
                color: '#2797FF',
                borderColor: '#DEDFE3',
                borderSize: 0,
                borderSizeMin: 0,
                borderSizeMax: 100,
                borderSizeStep: 100,
                borderRadius: 0,
                borderRadiusMin: 0,
                borderRadiusMax: 100,
                borderRadiusStep: 100,
            },
            defaultStyle: null,
            isLoadingDesignation: false,
            shortcode: '<a href="#" class="giverise-public-widgets" data-widget-id="{WIDGET_ID}" data-width="{WIDTH}" data-height="{HEIGHT}" style="display: none"></a>'
        };
    },
    computed: {
        amountCurrency() {
            return new Intl.NumberFormat().format(this.amount);
        },
    },
    watch: {
        campaign(val) {
            if (!this.isReadOnly && val) {
                this.getCampaignDesignations();
            }
        },
        defaultStyle(val) {
            if (val) {
                if (this.data) {
                    this.panelDesign.borderSizeMin = val.border_size.min
                    this.panelDesign.borderSizeMax = val.border_size.max
                    this.panelDesign.borderSizeStep = val.border_size.step

                    this.panelDesign.borderRadiusMin = val.border_radius.min
                    this.panelDesign.borderRadiusMax = val.border_radius.max
                    this.panelDesign.borderRadiusStep = val.border_radius.step

                    this.buttonDesign.borderSizeMin = val.button_border_size.min
                    this.buttonDesign.borderSizeMax = val.button_border_size.max
                    this.buttonDesign.borderSizeStep = val.button_border_size.step

                    this.buttonDesign.borderRadiusMin = val.button_border_radius.min
                    this.buttonDesign.borderRadiusMax = val.button_border_radius.max
                    this.buttonDesign.borderRadiusStep = val.button_border_radius.step
                } else {
                    this.panelDesign.backgroundColor = val.background_color
                    this.panelDesign.textColor = val.text_color
                    this.panelDesign.amountColor = val.amount_color
                    this.panelDesign.borderColor = val.border_color

                    this.panelDesign.borderSize = val.border_size.default
                    this.panelDesign.borderSizeMin = val.border_size.min
                    this.panelDesign.borderSizeMax = val.border_size.max
                    this.panelDesign.borderSizeStep = val.border_size.step

                    this.panelDesign.borderRadius = val.border_radius.default
                    this.panelDesign.borderRadiusMin = val.border_radius.min
                    this.panelDesign.borderRadiusMax = val.border_radius.max
                    this.panelDesign.borderRadiusStep = val.border_radius.step

                    this.buttonDesign.textColor = val.button_text_color
                    this.buttonDesign.color = val.button_color
                    this.buttonDesign.borderColor = val.button_border_color

                    this.buttonDesign.borderSize = val.button_border_size.default
                    this.buttonDesign.borderSizeMin = val.button_border_size.min
                    this.buttonDesign.borderSizeMax = val.button_border_size.max
                    this.buttonDesign.borderSizeStep = val.button_border_size.step

                    this.buttonDesign.borderRadius = val.button_border_radius.default
                    this.buttonDesign.borderRadiusMin = val.button_border_radius.min
                    this.buttonDesign.borderRadiusMax = val.button_border_radius.max
                    this.buttonDesign.borderRadiusStep = val.button_border_radius.step
                }

            }
        },
    },
    created() {
        if (this.data) {
            this.loadData();
        }
        this.getDefaultStyle();
    },
    methods: {
        loadData() {
            const val = this.data;
            if (val) {
                this.name = val.name;
                this.title = val.title;
                this.amount = val.amount;
                this.eventAmount = val.event_amount;
                this.allowChangeAmount = val.allow_change_amount;
                this.allowChangeDesignation = val.allow_change_designation;
                this.buttonLabel = val.button_text;
                this.description = val.description;
                this.panelDesign.backgroundColor = val.background_color;
                this.panelDesign.textColor = val.text_color;
                this.panelDesign.amountColor = val.amount_color;
                this.panelDesign.borderColor = val.border_color;
                this.panelDesign.borderSize = val.border_size;
                this.panelDesign.borderRadius = val.border_radius;
                this.buttonDesign.color = val.button_color;
                this.buttonDesign.textColor = val.button_text_color;
                this.buttonDesign.borderColor = val.button_border_color;
                this.buttonDesign.borderSize = val.button_border_size;
                this.buttonDesign.borderRadius = val.button_border_radius;
                this.campaign = this.isReadOnly ? this.campaignTitle : val.campaign_id;
                this.designation = this.isReadOnly ? this.designationName : (val.designation_id ? val.designation_id : '');

                this.shortcode = this.shortcode.replace('{WIDGET_ID}', val.widget_id)
                    .replace('{WIDTH}', '290')
                    .replace('{HEIGHT}', '257');

                this.htmlCode = this.shortcode
            }

        },
        getDefaultStyle() {
            const data = {
                '#request': DibbleApi.api.widgetGetDefaultStyle,
                type: 1,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.defaultStyle = response.style;
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
            });
        },
        closeModal() {
            this.$emit('close');
        },
        getCampaignDesignations() {
            this.designationList = [];
            this.isLoadingDesignation = true;

            const data = {
                '#request': DibbleApi.api.campaignGetDesignations,
                campaign_id: this.campaign
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    response.designations.forEach((item) => {
                        this.designationList.push({
                            label: item.name,
                            value: item.id,
                        });
                    });
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                this.isLoadingDesignation = false;
            });
        },
        handleChangeTab(tabIndex) {
            this.activeTab = tabIndex;
        },
        save() {
            const params = {
                campaign_id: this.campaign,
                designation_id: this.designation,
                name: this.name,
                title: this.title,
                amount: this.amount,
                event_amount: this.eventAmount,
                allow_change_amount: !!this.allowChangeAmount,
                allow_change_designation: !!this.allowChangeDesignation,
                button_text: this.buttonLabel,
                description: this.description,
                background_color: this.panelDesign.backgroundColor,
                text_color: this.panelDesign.textColor,
                amount_color: this.panelDesign.amountColor,
                border_color: this.panelDesign.borderColor,
                border_size: this.panelDesign.borderSize,
                border_radius: this.panelDesign.borderRadius,
                button_color: this.buttonDesign.color,
                button_text_color: this.buttonDesign.textColor,
                button_border_color: this.buttonDesign.borderColor,
                button_border_size: this.buttonDesign.borderSize,
                button_border_radius: this.buttonDesign.borderRadius,
            };

            if (this.data) {
                params.widget_id = this.data.widget_id;
            }

            DibbleJs.showLoader();
            const data = {
                '#request': this.data ? DibbleApi.api.widgetUpdateDonationBox : DibbleApi.api.widgetCreateDonationBox,
                ...params,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.$emit('success');
                    DibbleJs.toastSuccessMessage(this.data ? 'Widget updated successfully' : 'Widget created successfully');
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        copyToClipboard(code) {
            const el = document.createElement('textarea');
            el.value = code;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            DibbleJs.toastSuccessMessage('Copied to clipboard');
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 1000px !important;
}

.modal-content,
.modal-body {
    background: #edf5f7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1c5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1c5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}

.c-preview {
    padding: 24px;
    border-radius: 8px;
    border: 1px solid #ddd;
    width: 290px;
    height: 257px;
    aspect-ratio: 1;
    margin-bottom: 30px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;

    &__title {
        font-weight: 700;
        font-size: 18px;
        margin-bottom: 12px;
    }

    &__amount {
        font-size: 32px;
        color: #41b8dc;
        font-weight: 700;
        margin-bottom: 12px;
    }

    &__description {
        color: #000000;
        margin-bottom: 15px;
        font-size: 15px;
    }

    &__btn {
        font-size: 20px;
        width: 136px;
        height: 50px;
        font-weight: 600;
    }
}
.scroll-area {
    position: relative;
    margin: auto;
    height: auto;
    max-height: calc(100vh - 120px);
    overflow: auto;
}
.disabled-readonly {
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    opacity: 0.1;
    width: 100%;
    height: 100%;
    z-index: 9999;
}
</style>
<style type="text/css">
.scroll-area .ps__rail-y { display: none !important; }
.html-code .custom-form-control-type1 {
    padding-right: 50px;
}
</style>
